import CustomPagination from "@/components/custom/custom-pagination";
import CustomSearchInput from "@/components/custom/custom-search-input";
import CustomSelectInput from "@/components/custom/custom-select-input";
import { DataTable } from "@/components/custom/data-table";
import { TransactionColumns } from "@/components/transactions/transaction-columns";
import { useCollectionStats } from "@/hooks/use-collection-stats";
import { Stack, styled } from "@mui/material";
import { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";

const SectionRoot = styled("section")(({ theme }) => ({
  margin: theme.spacing(2),
}));

const Card = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "16px 20px",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Transaction = () => {
  const { productId } = useParams();
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get("search") || "";

  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);
  const status = searchParams.get("status");

  const queryParams = {
    page: currentPage,
    size: pageSize,
    status: status ? status : undefined,
    search: searchValue,
    channel: productId,
  };

  const {
    data: transactions,
    isLoading,
    isError,
  } = useCollectionStats(!!productId, queryParams);

  const columns = useMemo(() => TransactionColumns, []);

  return (
    <SectionRoot>
      <Card>
        <Stack direction="row" spacing={3} flexWrap="wrap">
          <CustomSearchInput
            paramKey="search"
            placeholder="Search transactions..."
          />
          <CustomSelectInput
            paramKey="status"
            label="Status"
            placeholder="All Status"
            options={[
              { label: "Successful", value: "SUCCESSFUL" },
              { label: "Pending", value: "PENDING" },
              { label: "Failed", value: "FAILED" },
            ]}
          />
        </Stack>

        <DataTable
          data={transactions?.data ?? []}
          columns={columns}
          isLoading={isLoading}
          isError={isError}
        />

        <CustomPagination
          total={transactions?.total_count ?? 0}
          perPageOptions={[5, 10, 20, 50, 100]}
        />
      </Card>
    </SectionRoot>
  );
};

export default Transaction;
